<template>
  <div class="homeView" @click="onScreenInteract" @touchstart.passive="onScreenInteract">
    <div v-if="showManageToolbar || showHistoryInfo" class="manageBtn">
      <div v-if="showManageToolbar">
        <el-button type="primary" icon="el-icon-user" @click="handleOnLogin"
          >登录</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-phone-outline"
          @click="callPhone"
          >呼叫帮助</el-button
        >
      </div>
      <div v-if="showHistoryInfo" class="historyNum">
        <span>上次打开日期：{{ historyDate }}</span
        >&nbsp;&nbsp;&nbsp;&nbsp;
        <span>上次打开柜号：{{ historyNum }}</span>
      </div>
    </div>
    <!-- v-if="gzInfo" -->
    <div class="home" :class="{ homeFullHeight: !showManageToolbar && !showHistoryInfo }">
      <div class="left">
        <div class="number">{{ gzInfo ? gzInfo.gateInfo.name : "--" }}</div>
        <div class="totalNumber">
          可用{{ gzInfo ? gzInfo.gzWsyCount : "--" }}/{{
            gzInfo ? gzInfo.gzCount : "--"
          }}
        </div>
        <div class="date">{{ currentTime }}</div>
        <div class="weekDate">
          {{ currentDate.split("/")[0] }}年{{ currentDate.split("/")[1] }}月{{
            currentDate.split("/")[2]
          }}日{{ currentWeekday }}
        </div>
      </div>
      <div class="center centerIdle">
        <div class="idleTip">请刷掌或手环进行存取</div>
      </div>
      <div v-if="showCabinetActions" class="right cabinetFlex">
        <span class="cabinetBtn" @click="handleOnCabinet('store')">存</span>
        <span class="cabinetBtn" @click="handleOnCabinet('take')">取</span>
      </div>
    </div>
    <el-dialog title="登录" :visible.sync="dialogFormVisible">
      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-form-item
          label="密码"
          prop="password"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="form.password"
            placeholder="请输入密码"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleOnClose">取 消</el-button>
        <el-button type="primary" @click="handleOnConfirm">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="cainetTitle"
      :visible.sync="dialogSelectVisible"
      width="40%"
      custom-class="cabinetDialog"
    >
      <div class="cabinetFlex" style="height: 300px">
        <span
          :class="[curIndex == index ? 'cabinetBtn active' : 'cabinetBtn']"
          v-for="(item, index) in cabinetTypeList"
          :key="index"
          @click="handleOnSelectCabinet(item, index)"
          >{{ item }}</span
        >
      </div>
      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="handleOnCancelCabinet">取 消</el-button>
        <el-button type="primary" @click="handelOnConfirmSelect"
          >确 定</el-button
        >
      </span> -->
    </el-dialog>


    <el-dialog
      title="开柜提示"
      :visible.sync="openCabinetDialogVisible"
      width="52%"
      custom-class="openCabinetDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div class="openCabinetDialogBody">
        <p class="openCabinetText">
          已打开柜号：<span>{{ openCabinetDialogNumber }}</span>
        </p>
        <p class="openCabinetCountdown">
          {{ openCabinetCountdown }}s 后自动关闭
        </p>
      </div>
      <div slot="footer" class="openCabinetDialogFooter">
        <el-button type="primary" size="medium" @click="closeOpenCabinetDialog">
          关 闭
        </el-button>
      </div>
    </el-dialog>

    <!-- 音频播放器（不会显示，仅用于播放） -->

    <audio ref="audioPlayer" preload="auto" playsinline webkit-playsinline></audio>
    <button ref="videoPlay" @click="playAudio" class="playVideo">播放</button>

  </div>
</template>
<script>
// @ is an alias to /src
import axios from "axios";
import moment from "moment";
import { API_BASE } from "@/config/api";
import { notifyRequestError } from "@/utils/requestError";
import {
  playVoiceAudio,
  playVoiceText,
  extractGzMessageText,
  bindAudioUnlock,
  unlockAudioPlayback,
  resolveVoiceMp3,
} from "@/utils/voicePlayer";
export default {
  name: "HomeView",
  components: {},
  data() {
    return {
      currentDate: "",
      currentTime: "",
      currentWeekday: "",
      gzInfo: null,
      pollInterval: 3000,
      pollTimer: null,
      deviceInfoLoading: false,
      dialogFormVisible: false,
      form: {
        password: "",
      },
      subType: "",
      formLabelWidth: "120px",
      rules: {
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
      selectRules: {
        subType: [{ required: true, message: "请选择类型", trigger: "change" }],
      },
      cainetTitle: "我要存",
      cabinetTypeList: [],
      deviceKey: "",
      historyNum: "--",
      historyDate: "--",
      isAutoplay: false,
      dialogSelectVisible: false,
      curIndex: null,
      showManageToolbar: false,
      showHistoryInfo: false,
      showCabinetActions: false,
      openCabinetDialogVisible: false,
      openCabinetDialogNumber: "",
      openCabinetVoiceText: "",
      openCabinetCountdown: 60,
      openCabinetCountdownTimer: null,
      lastOpenCabinetNoticeKey: "",
      audioUnlocked: false,
    };
  },
  created() {
    setInterval(() => {
      this.getCurrentDateTime();
      this.getCurrentWeekday();
    }, 1000);
  },
  mounted() {
    console.log(window.location.href);
    this.deviceKey = window.location.href.split("=")[1];
    this.getdeviceInfoApi();
    this.startPollTimer();
    let locationHref = window.location.href.split("=")[0];
    setInterval(() => {
      location.href = locationHref + "=" + this.deviceKey;
    }, 3600000);
    this.$nextTick(() => {
      bindAudioUnlock(this.$refs.audioPlayer);
    });
  },
  methods: {
    onScreenInteract() {
      const audio = this.$refs.audioPlayer;
      if (!audio) return;
      unlockAudioPlayback(audio).then((ok) => {
        if (!ok) return;
        this.audioUnlocked = true;
        if (this.openCabinetDialogVisible && this.openCabinetVoiceText) {
          this.playGzMessageVoice(this.openCabinetVoiceText);
        }
      });
    },
    playAudio() {
      const audio = this.$refs.audioPlayer;
      if (audio && audio.src) {
        playVoiceAudio(audio, audio.src, undefined, "manual");
      }
    },
    callPhone() {
      var that = this;
      axios
        .get(
          `${API_BASE}/index.php?d=api&c=openApi&m=doTel&deviceKey=` +
            that.deviceKey
        )
        .then(function (res) {
          console.log(res);
          that.$message({
            message: "已呼叫前台，请等待！",
            type: "success",
            duration: 3000,
          });
        })
        .catch(function (error) {
          notifyRequestError(error);
        });
    },
    //登录
    handleOnLogin() {
      this.dialogFormVisible = true;
    },
    //取消
    handleOnClose() {
      this.dialogFormVisible = false;
      this.form.password = "";
    },
    //选择柜子类型
    handleOnSelectCabinet(val, index) {
      this.curIndex = index;
      this.subType = val;
      this.handelOnConfirmSelect()
    },
    //确认登录
    handleOnConfirm() {
      var that = this;
      that.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          axios
            .get(
              `${API_BASE}/index.php?c=api&m=doLogin&password=` +
                this.form.password
            )
            .then(function (res) {
              console.log(res);
              if (res.data.code == 200) {
                localStorage.setItem("userId", res.data.data.userId);
                that.$router.push({
                  name: "cabinetDoor",
                  params: { deviceKey: that.deviceKey },
                });
              }
            })
            .catch(function (error) {
              notifyRequestError(error);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //选择存取类型
    handleOnCabinet(type) {
      // 获取音频元素
      const audio = this.$refs.audioPlayer;
      if (type == "store") {
        this.cainetTitle = "我要存";
        this.cabinetTypeList = ["上柜", "中柜", "下柜"];
        const src = this.mp3Path("position");
        if (src) playVoiceAudio(audio, src, undefined, "position");
      } else {
        this.cainetTitle = "我要取";
        this.cabinetTypeList = ["临时取", "离场取"];
        const src = this.mp3Path("style");
        if (src) playVoiceAudio(audio, src, undefined, "style");
      }
      this.curIndex = null;
      this.subType = "";
      this.dialogSelectVisible = true;
    },
    handelOnConfirmSelect() {
      var that = this;
      if (!that.subType) {
        that.$message.warning(
          that.cainetTitle == "我要存" ? "请选择柜层位置！" : "请选择取物方式！"
        );
        return;
      }
      axios
        .post(`${API_BASE}/index.php?c=api&m=doStorage`, {
          type: that.cainetTitle == "我要存" ? "存" : "取",
          subType: that.subType,
          deviceKey: that.deviceKey,
          mendian_id: 4,
        })
        .then(function (res) {
          console.log(res);
          if (res.data.code == 200) {
            that.dialogSelectVisible = false;
            // 获取音频元素
            const scanSrc = that.mp3Path("scan");
            if (scanSrc) {
              playVoiceAudio(that.$refs.audioPlayer, scanSrc, undefined, "scan");
            }
          } else {
            that.$message.warning(res.data.msg);
          }
        })
        .catch(function (error) {
          notifyRequestError(error);
        });
    },
    handleOnCancelCabinet() {
      this.dialogSelectVisible = false;
      this.curIndex = null;
      this.subType = "";
    },
    startPollTimer() {
      this.stopPollTimer();
      this.pollTimer = setInterval(() => {
        this.getdeviceInfoApi();
      }, this.pollInterval);
    },
    stopPollTimer() {
      if (this.pollTimer) {
        clearInterval(this.pollTimer);
        this.pollTimer = null;
      }
    },
    mp3Path(val) {
      return resolveVoiceMp3(val);
    },
    showOpenCabinetDialog(msg) {
      const nameBox =
        msg && typeof msg === "object" ? msg.name_box : msg;
      this.openCabinetDialogNumber = nameBox || "";
      this.openCabinetVoiceText = extractGzMessageText(msg);
      this.openCabinetDialogVisible = true;
      this.openCabinetCountdown = 60;
      this.clearOpenCabinetCountdownTimer();
      this.openCabinetCountdownTimer = setInterval(() => {
        if (this.openCabinetCountdown <= 1) {
          this.closeOpenCabinetDialog();
        } else {
          this.openCabinetCountdown--;
        }
      }, 1000);
      this.$nextTick(() => {
        this.playGzMessageVoice(msg);
      });
    },
    playGzMessageVoice(msg) {
      const text =
        typeof msg === "string"
          ? msg.trim()
          : extractGzMessageText(msg) || this.openCabinetVoiceText;
      if (!text) return;
      const audio = this.$refs.audioPlayer;
      if (!audio) return;
      playVoiceText(audio, text, "gzMessage");
    },
    closeOpenCabinetDialog() {
      this.openCabinetDialogVisible = false;
      this.clearOpenCabinetCountdownTimer();
    },
    clearOpenCabinetCountdownTimer() {
      if (this.openCabinetCountdownTimer) {
        clearInterval(this.openCabinetCountdownTimer);
        this.openCabinetCountdownTimer = null;
      }
    },
    getdeviceInfoApi() {
      var that = this;
      if (that.deviceInfoLoading) return;
      that.deviceInfoLoading = true;
      axios
        .get(
          `${API_BASE}/index.php?c=api&m=getGzMessage&deviceKey=` +
            this.deviceKey
        )
        .then(function (response) {
          if (response.data.code == 200) {
            if (!response.data.data.gzMessage) {
              that.historyNum = localStorage.getItem("historyNnm") || "--";
              that.historyDate = localStorage.getItem("historyDate") || "--";
              that.lastOpenCabinetNoticeKey = "";
            }
            that.gzInfo = response.data.data;
            if (that.gzInfo.gzMessage) {
              const msg = that.gzInfo.gzMessage;
              const noticeKey = `${msg.name_box}_${msg.addtime}`;
              if (noticeKey !== that.lastOpenCabinetNoticeKey) {
                that.lastOpenCabinetNoticeKey = noticeKey;
                that.showOpenCabinetDialog(msg);
              }
              localStorage.setItem("historyNnm", msg.name_box);
              localStorage.setItem("historyDate", msg.addtime);
            }
          }
        })
        .catch(function (error) {
          notifyRequestError(error, { throttleKey: "getGzMessage" });
        })
        .finally(function () {
          that.deviceInfoLoading = false;
        });
    },

    getCurrentDateTime() {
      const now = new Date();
      this.currentDate = now.toLocaleDateString();
      // this.currentTime = now.toLocaleTimeString(); // 时分秒格式
      this.currentTime = now.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      }); //时分格式
    },
    getCurrentWeekday() {
      const weekdays = [
        "星期日",
        "星期一",
        "星期二",
        "星期三",
        "星期四",
        "星期五",
        "星期六",
      ];
      const now = new Date();
      this.currentWeekday = weekdays[now.getDay()];
    },
  },
  beforeDestroy() {
    this.stopPollTimer();
    this.clearOpenCabinetCountdownTimer();
  },
};
</script>
<style scoped lang="scss">
.homeView {
  height: 100vh;
  background: url("../assets/index_bg.jpg") no-repeat;
  background-size: 100% 100%;
  position: relative;
::v-deep(.openCabinetDialog) {
  border-radius: 24px;
  .el-dialog__title { font-size: 28px; font-weight: bold; }
  .openCabinetDialogBody {
    text-align: center;
    padding: 20px 0 10px;
    .openCabinetText {
      font-size: 36px;
      color: #303133;
      margin: 0 0 24px;
      span { color: #0560d1; font-weight: bold; font-size: 48px; }
    }
    .openCabinetCountdown { font-size: 22px; color: #909399; margin: 0; }
  }
  .openCabinetDialogFooter {
    text-align: center;
    .el-button { min-width: 140px; font-size: 22px; padding: 14px 36px; }
  }
}

  .playVideo {
    opacity: 0;
    position: absolute;
    bottom: 0;
    left: 0;
  }
  .manageBtn {
    padding: 16px 26px 0;
    display: flex;
    justify-content: space-between;
    align-items: Center;
    color: #fff;
    .el-button--primary {
      background: #658ecc;
      font-size: 24px;
      border: 1px solid #658ecc;
    }
    .historyNum {
      font-size: 24px;
    }
  }
  .home {
    color: #fff;
    height: calc(100vh - 68px);
    display: flex;
    justify-content: space-between;
    align-items: Center;
    &.homeFullHeight {
      height: 100vh;
    }
    .center {
      flex: 1;
      text-align: center;
      font-size: 56px;
      font-weight: bold;
      &.centerIdle {
        flex: 2;
        .idleTip {
          font-size: 64px;
          line-height: 1.4;
          color: #9bf0f4;
          letter-spacing: 2px;
          transform: translateX(-28px);
        }
      }
      &:not(.centerIdle) div:last-child {
        font-size: 100px;
        margin-top: 20px;
      }
    }
    .left {
      text-align: center;
      flex: 1;
      .totalNumber {
        color: #9bf0f4;
        font-size: 48px;
        font-weight: bold;
        margin: 20px 0 40px;
      }
      .number {
        color: #9bf0f4;
        font-size: 52px;
        font-weight: bold;
      }
      .date {
        color: #fff;
        font-size: 74px;
        font-weight: bold;
        margin-bottom: 12px;
      }
      .weekDate {
        color: #fff;
        font-size: 26px;
        font-weight: bold;
      }
    }
    .right {
    }
  }
}
::v-deep(.cabinetDialog) {
  border-radius: 40px;
  .el-dialog__title {
    font-size: 26px;
  }
}
</style>
<style lang="scss">
.cabinetFlex {
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: Center;
  span.cabinetBtn {
    display: inline-block;
    width: 140px;
    height: 100px;
    border-radius: 60%;
    background: linear-gradient(to right, #0560d1, #c1fafe);
    font-size: 40px;
    text-align: center;
    line-height: 100px;
    margin-left: 10%;
    color: #fff;
    cursor: pointer;
    /* 触屏长按时禁止选中文字，确保能正常触发点击 */
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    -webkit-touch-callout: none;
    &.active {
      background: linear-gradient(to right, #5b03ad, #bba8bb);
    }
    &:first-child {
      margin-left: 0;
    }
  }
}
</style>